export enum TicketFormOptions {
	Name = 'name',
	Email = 'email',
	Message = 'message',
}

export type TicketForm = TicketFormOptions.Name | TicketFormOptions.Email | TicketFormOptions.Message

export type TicketFormValues = Record<TicketForm, string>
